import { render } from "./SignatureCol.vue?vue&type=template&id=36ed1ee7&ts=true"
import script from "./SignatureCol.vue?vue&type=script&lang=ts"
export * from "./SignatureCol.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__